import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationStore } from 'src/app/stores/authentication.store';

@Component({
  selector: 'app-sort-and-filter-component',
  templateUrl: './sort-and-filter-component.component.html',
  styleUrls: ['./sort-and-filter-component.component.scss'],
})
export class SortAndFilterComponentComponent implements OnInit {
  @Output() refreshProducts = new EventEmitter();
  @Output() refreshFilterProducts = new EventEmitter();
  isClear = false;
  constructor(private auth: AuthenticationStore) {
    this.auth.isClear.subscribe((data) => {
      if (data === 'clear') {
        this.isClear = false;
      } else {
        this.isClear = true;
      }
    });
  }

  ngOnInit() {}
  clearilter() {
    this.auth.clearAll.next(true);
    this.auth.isClear.next('clear');
  }

  sortBy(event) {
    this.refreshProducts.emit(event);
  }

  filter(event) {
    this.refreshFilterProducts.emit(event);
  }
}
